import { ChangeDetectorRef, Component, ViewContainerRef } from '@angular/core';
import { AngularComponentFactory } from 'survey-angular-ui';
import { OfficeSearchWidgetModel } from './office-search.widget.model';
import { RendererFactory } from 'survey-core';
import { FormBuilder, Validators } from '@angular/forms';
import { OfficeSearchWidgetJson } from './office-search.widget.json';
import { SurveyService } from '../../../../core/services/survey/survey.service';
import { OfficeSearchWidgetService } from './services/office-search.widget.service';
import { OfficeSearchProcessWidgetService } from './services/office-search-process.widget.service';
import {
  FindBrokerOfficesApiService,
  FindOfficesApiService,
  NrdsOfficesApiService,
  SnackbarService
} from '@tangilla/tg-ng-core';
import { RequestParameters } from '@tangilla/tg-ng-models';
import { VariablesService } from '../../../../core/services/survey/variables.service';
import { QuestionsService } from '../../../../core/services/survey/questions.service';
import { OfficeSearchDrSearchWidgetService } from './services/office-serach-dr-search.service';
import { TangillaQuestion } from '../tangilla-question';
import { Subscription } from 'rxjs';
import { ErrorsService } from '../../../../core/services/utils/errors.service';

@Component({
  selector: 'tgf-office-search-widget',
  templateUrl: './office-search.widget.component.html',
  styleUrls: ['./office-search.widget.component.scss']
})
export class OfficeSearchWidgetComponent extends TangillaQuestion<OfficeSearchWidgetModel> {
  autoCompleteBrokerLicenseNumber: any;
  questionJson: any;

  isLoading = false;
  isLoadingSearchOffice = false;
  isCorporate = false;
  isValidOffice = false;
  OfficeSearchWidgetJson = new OfficeSearchWidgetJson();

  isAutoSearch = false;

  officeSubscription?: Subscription;
  drOfficesSubscription?: Subscription;

  constructor(
    private officeSearchWidgetService: OfficeSearchWidgetService,
    private officeSearchProcessWidgetService: OfficeSearchProcessWidgetService,
    private officeSearchDrSearchWidgetService: OfficeSearchDrSearchWidgetService,
    private snackbarService: SnackbarService,
    public findOfficesApiService: FindOfficesApiService,
    public findBrokerOfficesApiService: FindBrokerOfficesApiService,
    public nrdsOfficesApiService: NrdsOfficesApiService,
    public variablesService: VariablesService,
    private errorsService: ErrorsService,
    formBuilder: FormBuilder,
    surveyService: SurveyService,
    questionsService: QuestionsService,
    changeDetectorRef: ChangeDetectorRef,
    viewContainerRef?: ViewContainerRef
  ) {
    super(formBuilder, surveyService, questionsService, changeDetectorRef, viewContainerRef);
  }

  override async ngOnInit() {
    super.ngOnInit();

    this.initForm();
    if (this.questionsService.office?.value) {
      if (!this.isDrOfficeSearch() && this.canAutoSearch()) {
        this.autoSearch();
      } else {
        await this.doSearch();
      }
    } else if (!this.isDrOfficeSearch()) {
      this.autoSearch();
    }
  }

  override ngOnDestroy() {
    super.ngOnDestroy();
    if (this.officeSubscription) {
      this.officeSubscription.unsubscribe();
    }
    if (this.drOfficesSubscription) {
      this.drOfficesSubscription.unsubscribe();
    }
  }

  initForm() {
    this.OfficeSearchWidgetJson.showSearchFields = true;
    this.addOfficeSearchControls();
    this.mapQuestionJson();
    this.questionForm.valueChanges.subscribe(data => {
      this.changeDetectorRef.detectChanges();
    });
  }

  isDrOfficeSearch() {
    return this.getJsonObj(this.model).isDrOfficeSearch;
  }

  getJsonObj(model: any): any {
    return model?.jsonObj;
  }

  addOfficeSearchControls() {
    this.addFormControl(
      'office_search',
      this.getQuestionName('officeSearch', 'Office-Search'),
      [],
      this.getQuestionValue('officeSearch', 'Office-Search') || '');

    this.addFormControl(
      'city',
      this.getQuestionName('officeSearchCity', 'Office-Search-City'),
      [],
      this.getQuestionValue('officeSearchCity', 'Office-Search-City') || '');

    this.addFormControl(
      'state',
      this.getQuestionName('officeSearchState', 'Office-Search-State'),
      [],
      this.getQuestionValue('officeSearchState', 'Office-Search-State') || this.variablesService.state);

    this.addFormControl(
      'office_selected',
      this.getQuestionName('office'),
      [],
      this.getQuestionValue('office'));
  }

  mapQuestionJson() {
    const questionJson = this.OfficeSearchWidgetJson.getWidgetJson(this.questionForm!, this.questionModel);
    questionJson.valueChangesFunctions = {};
    questionJson.valueChangesFunctions.office_selected = (office: string) => {
      if (office) {
        this.model.value = true;
      } else {
        this.model.value = undefined;
      }
    };
    this.questionJson = questionJson;
  }

  search() {
    const that = this;
    this.submitForm(() => that.doSearch());
  }

  async doSearch() {
    if (this.isDrOfficeSearch()) {
      await this.getDrOffices();
    } else {
      this.getOffices();
    }
  }

  async getDrOffices() {
    this.model.clearErrors();
    this.model.value = undefined;
    if (!this.isAutoSearch && this.questionForm.getRawValue().office_search == '') {
      this.model.addError('Please type your office name to search.');
      return;
    }
    this.isLoadingSearchOffice = true;
    const officeRadioGroupQuestion = this.officeSearchProcessWidgetService.getOfficesRadioGroupQuestion(this.questionJson);
    if (officeRadioGroupQuestion) {
      officeRadioGroupQuestion.choices = [];
    }
    this.changeDetectorRef.detectChanges();
    const body = this.formToEntity();
    const {brokerOffices, resultNrdsOffices} = await this.officeSearchDrSearchWidgetService.getDrOffices(body);

    const drFirstName = this.surveyService.memberRecord.first_name;
    const drLastName = this.surveyService.memberRecord.last_name;

    if (resultNrdsOffices) {
      this.drOfficesSubscription = resultNrdsOffices.subscribe({
        next: (data: any) => {
          let filteredData = data.filter((office: any) => office.status === 'A' &&
            office.dr_last_name === drLastName &&
            office.dr_first_name === drFirstName &&
            !brokerOffices.includes(office.office_nrds_id));

          if (data.length > 0) {
            this.officeSearchProcessWidgetService.processOfficesResult(filteredData, this.questionJson);
          } else {
            this.dataNotFound();
          }

          this.isLoadingSearchOffice = false;
          this.changeDetectorRef.detectChanges();
        },
        error: (error: any) => {
          this.isLoadingSearchOffice = false;
          this.changeDetectorRef.detectChanges();
          this.errorsService.processError(error, 'soft');
          this.changeDetectorRef.detectChanges();
        }
      });
    }
  }

  getOffices() {
    this.model.clearErrors();
    this.model.value = undefined;

    if (!this.isAutoSearch && this.questionForm.getRawValue().office_search == '') {
      this.model.addError('Please type your office name to search.');
      return;
    }
    this.isLoadingSearchOffice = true;
    const officeRadioGroupQuestion = this.officeSearchProcessWidgetService.getOfficesRadioGroupQuestion(this.questionJson);
    if (officeRadioGroupQuestion) {
      officeRadioGroupQuestion.choices = [];
    }

    this.changeDetectorRef.detectChanges();
    const body = this.formToEntity();

    const {
      searchFunctionType,
      queryParameters
    } = this.officeSearchWidgetService.getOffices(this.isCorporate, body, this.autoCompleteBrokerLicenseNumber);

    const parameters = (new RequestParameters(null)).setAdditionalFields(queryParameters);
    const getOfficeFunction = this.getOfficeMethod(searchFunctionType, parameters);

    if (getOfficeFunction) {
      this.officeSubscription = getOfficeFunction.subscribe({
        next: (data: any) => {
          if (data.length > 0) {
            this.officeSearchProcessWidgetService.processOfficesResult(data, this.questionJson);
          } else {
            this.dataNotFound();
          }
          this.isLoadingSearchOffice = false;
          this.changeDetectorRef.detectChanges();
        },
        error: (error: any) => {
          this.isLoadingSearchOffice = false;
          this.changeDetectorRef.detectChanges();
          this.errorsService.processError(error, 'soft');
          this.changeDetectorRef.detectChanges();
        }
      });
    }
  }

  dataNotFound() {
    this.model.addError('We have not been able to find an active office based on that search, please try again.');
  }

  getOfficeMethod(methodType: string, parameters: any): any {
    switch (methodType) {
      case 'findOffices':
        return this.findOfficesApiService.getAll(parameters);
      case 'findBroker':
        return this.findBrokerOfficesApiService.getAll(parameters);
      case 'nrdsOffices':
        return this.nrdsOfficesApiService.getAll(parameters);
    }
    return;
  }

  formToEntity() {
    const formValue = this.questionForm.getRawValue();

    return {
      ...formValue,
      state: formValue.state || this.surveyService.surveyModel.getVariable('v-state'),
      encodedSearch: encodeURIComponent(formValue.office_search)
    };
  }

  autoSearch() {
    this.changeDetectorRef.detectChanges();

    this.autoCompleteBrokerLicenseNumber = this.surveyService.surveyModel.getValue('BrkLic');

    if (this.canAutoSearch()) {
      if (this.surveyService.surveyModel.getValue('MembershipType') === 'NUA' || this.surveyService.surveyModel.getValue('LicType') === 'Appraiser Trainee') {
        this.surveyService.surveyModel.setValue('OfficeSearchType', 'Office');
      } else {
        this.surveyService.surveyModel.setValue('OfficeSearchType', 'Broker');
      }
      if (this.surveyService.surveyModel.getVariable('license_affiliations_enabled') === true && this.surveyService.surveyModel.getValue('AffiliatedLicense')) {
        this.autoCompleteBrokerLicenseNumber = this.surveyService.surveyModel.getValue('AffiliatedLicense');
      } else if (this.surveyService.surveyModel.getQuestionByName('CorpLic') && !this.surveyService.surveyModel.getQuestionByName('CorpLic')?.isEmpty() && this.surveyService.searchByCorpLicense) {
        this.autoCompleteBrokerLicenseNumber = this.surveyService.surveyModel.getQuestionByName('CorpLic').value;
        this.isCorporate = this.surveyService.searchByCorpLicense;
      } else if (this.surveyService.surveyModel.getQuestionByName('BrokerLicense') && !this.surveyService.surveyModel.getQuestionByName('BrokerLicense').isEmpty()) {
        this.autoCompleteBrokerLicenseNumber = this.surveyService.surveyModel.getQuestionByName('BrkLic').value;
        this.isCorporate = this.surveyService.surveyModel.getValue('BrkLicType') === 'Corporation';
      }

      if (this.autoCompleteBrokerLicenseNumber) {
        this.OfficeSearchWidgetJson.showSearchFields = false;
        this.isAutoSearch = true;
        this.getOffices();
      }
    }
    this.changeDetectorRef.detectChanges();
  }

  canAutoSearch() {
    return this.questionsService.licenseType && this.questionsService.licenseType.value === 'Salesperson';
  }

  isItLoading() {
    return this.isLoading || this.isLoadingSearchOffice;
  }
}

RendererFactory.Instance.registerRenderer(
  'office_search',
  'office_search',
  'tg_office_search',
  true
);
AngularComponentFactory.Instance.registerComponent('tg_office_search', OfficeSearchWidgetComponent);
